export default __webpack_public_path__ + "static/media/review.b0022feb.jpg";